<template>
	<div
		class="font-weight-default wrapper font-body position-relative cursor-pointer form-control h-100 w-100 d-flex justify-content-between p-0"
		:style="{ color: colors.black }"
	>
		<!-- Add the label here, above the trigger button -->
		<div class="label" :class="{ 'text-primary-blue': participantsDropdownOpen, 'bg-grey-200': disabled }">
			{{ content.planner_prestationsParticipants }}
		</div>
		
		<ParticipantsDropdown
			v-if="!disableParticipantsDropdown"
			:disabled="disabled"
			@closeClick="() => handleCloseClick()"
			@setParticipants="(newArray) => handleSetParticipants(newArray)"
			@notEnoughAdults="$emit('notEnoughAdults')"
			:maxParticipants="availableFlightPackCodes ? 9: 20"
		/>
		<div
			@click.stop="handleClick"
			:style="
				participantsDropdownOpen && {
					color: colors.darkBlue,
				}
			"
			class="text-end participants-main-btn d-flex flex-row nowrap justify-content-between align-items-center w-100 px-3 py-3"
			:class="{ disabled: disableParticipantsDropdown }"
		>
			<template v-if="participants.length > 0">
				<ParticipantsTotals :participants="participants" :content="content" />
			</template>
			<span v-else class="noParticipants ms-2 text-lowercase">{{
				content.planner_participants
			}}</span>

			<svg
				v-if="participantsDropdownOpen && !disableParticipantsDropdown"
				:color="colors.black"
				:width="iconSizes.s"
				:height="iconSizes.s"
				class="icon"
			>
				<use :xlink:href="`#___icon___chevron-up-bold`"></use>
			</svg>
			<svg
				v-else-if="!participantsDropdownOpen && !disableParticipantsDropdown"
				:color="colors.black"
				:width="iconSizes.s"
				:height="iconSizes.s"
				class="icon"
			>
				<use :xlink:href="`#___icon___chevron-down-bold`"></use>
			</svg>
		</div>
	</div>
</template>

<script>
import ParticipantsDropdown from "@/vue/planning/components/search/participantsDropdown.vue";
import ParticipantsTotals from "@/vue/planning/components/common/participantsTotals.vue";
import colors from "@/config/colors";
import iconSizes from "@/config/iconSizes";
import flightPackCode from "@/config/flightPackCode"
import { mapState, mapGetters } from "vuex";

import { getCompanyCookie } from "@/utils/utils";


export default {

	name: "Participants",
	components: {
		ParticipantsDropdown,
		ParticipantsTotals,
	},
	data() {
		return {
			colors,
			iconSizes,
		};
	},
	computed: {
		...mapState([
			"content",
			"participants",
			"participantsDropdownOpen",
			"loading",
			"locale",
		]),
		...mapGetters(["locale", "availablePackCodes"]),

		disabled() {
			return this.loading;
		},
		numAdults() {
			return this.participants.filter((age) => age >= 18).length;
		},
		numChildren() {
			return this.participants.filter((age) => age < 18).length;
		},
		isLocaleCSE() {
			return this.locale === "fr_FR_CSE";
		},
		disableParticipantsDropdown() {
			const company = getCompanyCookie();
			return this.isLocaleCSE && (company === "cgos" || company === "cgosaura" || company === "CGOSPM");
		},
		availableFlightPackCodes() {
			return flightPackCode.includes(this.$store.state.packCode);
		}

	},
	methods: {
		handleClick() {
			console.log(
				"[Participants] handleClick – disabled:",
				this.disabled,
				"disableParticipantsDropdown:",
				this.disableParticipantsDropdown,
				"wasOpen:",
				this.participantsDropdownOpen
			);
			if (!this.disabled && !this.disableParticipantsDropdown)
		
				this.$emit("changeOpenParticipants", !this.participantsDropdownOpen);
		},
		handleCloseClick() {
			console.log("[Participants] handleCloseClick – closing dropdown");
			if (!this.disabled) this.$emit("changeOpenParticipants", false);
		},
		handleSetParticipants(newArray) {
			if (!this.disabled) this.$emit("setParticipants", newArray);
		},
	},
	mounted() {
		if (flightPackCode.includes(this.$store.state.packCode) && this.participants.length > 9) {
			this.$emit("setParticipants", this.participants.slice(0, 9));
		}
	},
};
</script>

<style scoped>
.wrapper,
.participants-main-btn {
	border-radius: var(--border-radius-default) !important;
}

.disabled {
	background-color: lightgrey;
}
.wrapper {
  overflow: visible !important;
}

.label {
	position: absolute;
	top: -8px;
	left: 12px;
	background-color: white;
	padding: 0 6px;
	font-size: 12px;
	color: black;
	z-index: 1;
	font-weight: 500;
}
</style>
